import store from '@/store';
import axios from 'axios';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'CreateRefundForm', namespaced: true})
export default class CreateRefundForm extends VuexModule {

    public createRefundPopupVisibility: boolean = false;


    get getCreateRefundPopupVisibility() {
        return this.createRefundPopupVisibility;
    }

    @Mutation
    public SET_CREATE_REFUND_POPUP_VISIBILITY(visibility: boolean) {
        this.createRefundPopupVisibility = visibility;
    }

    @Action
    public TOGGLE_CREATE_REFUND_POPUP_VISIBILITY(visibility: boolean) {
        store.commit(Mutations.SET_CREATE_REFUND_POPUP_VISIBILITY, visibility);
    }

    @Action
    public SAVE_NEW_REFUND(data: any) {
        axios.post(Endpoints.Admin.Finances.SAVE_NEW_REFUND(data.unitId), data)
            .then((response) => {
                store.commit(Mutations.SET_CREATE_REFUND_POPUP_VISIBILITY, false);
                if (data.ordersPage) {
                    store.dispatch(Actions.FETCH_UNIT_ORDERS, data.unitId);
                } else if (data.balanceAccountPage) {
                    store.dispatch(Actions.FETCH_UNIT_BALANCE_ACCOUNT_DATA, data.unitId);
                } else if (data.refundsPage) {
                    store.dispatch(Actions.FETCH_REFUNDS_FINANCE_DATA, data.unitId);
                }
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }


}
